export const geocodingService = {
  searchLocation: async (query) => {
    if (!query || query.length < 3) return [];
    
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=5`
      );
      
      if (!response.ok) {
        throw new Error('Geocoding service error');
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching location:', error);
      return [];
    }
  }
};
